import { Switch } from "@nextui-org/react";
import { MoonIcon, SunIcon } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export function ModeToggle() {
	const [mounted, setMounted] = useState(false);
	const { theme, setTheme } = useTheme();

	useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted) return null;

	return (
		<Switch
			defaultSelected={theme !== "dark"}
			size="sm"
			color="success"
			startContent={<SunIcon />}
			endContent={<MoonIcon />}
			onValueChange={() => setTheme(theme === "dark" ? "light" : "dark")}
		/>
	);
}
